import backToTopSvg from '@/assets/icons/back-to-top.svg'
import lockSvg from '@/assets/icons/lock.svg'
import poweredByStripeSvg from '@/assets/icons/powered-by-stripe.svg'
import facebookSvg from '@/assets/icons/social/facebook.svg'
import instagramSvg from '@/assets/icons/social/instagram.svg'
import linkedinSvg from '@/assets/icons/social/linkedin.svg'
import xSvg from '@/assets/icons/social/x.svg'
import LogoSvg from '@/assets/images/logo.svg?react'
import {
  ACCESSIBILITY_STATEMENT,
  ADDRESS,
  EMAIL,
  PRIVACY_POLICY,
  SHIPPING_AND_RETURN,
  SOCIAL_MEDIA,
  TERMS_OF_USE,
} from '@/constants/contacts'
import isInApp from '@/lib/in-app/utils/isInApp'
import {AboutUsRoute, ContactUsRoute, HomeRoute} from '@/routeRegistry'
import VisuallyHidden from '@/utils/a11y/VisuallyHidden'

import style from './Footer.module.scss'

export default memo(function Footer() {
  if (isInApp()) {
    return null
  }

  return (
    <footer className={style.Footer}>
      <div>
        <LogoSvg className={style.Logo} aria-hidden />
      </div>
      <div className={style.MainContent}>
        <div className={style.Col} aria-hidden>
          <div className={style.Headline}>All-in-One {'\n'}Shopping Platform</div>
          <div className={style.Trust}>
            <img src={lockSvg} alt='' />
            <span>
              Guaranteed <strong>safe & secure</strong> checkout
            </span>
            <img src={poweredByStripeSvg} alt='Powered by Stripe' loading='lazy' />
          </div>
        </div>
        <VisuallyHidden as='div'>
          <span>All-in-One Shopping Platform</span>
          <br />
          <span>Guaranteed safe & secure checkout, powered by Stripe</span>
        </VisuallyHidden>
        <div className={style.Col}>
          <ul className={style.Navigation} aria-label='Navigation links'>
            <li>
              <Link to={HomeRoute.fullPath}>Home</Link>
            </li>
            <li>
              <Link to={ContactUsRoute.fullPath}>Contact</Link>
            </li>
            <li>
              {/* TODO: update if blog have a test version */}
              <a href={'https://blog.innosearch.ai'}>Blog</a>
            </li>
            <li>
              <Link to={AboutUsRoute.fullPath}>About Us</Link>
            </li>
            <li>
              <a href={PRIVACY_POLICY} target='_blank' rel='noreferrer'>
                Privacy Policy
              </a>
            </li>
            <li>
              <a href={TERMS_OF_USE} target='_blank' rel='noreferrer'>
                Terms of Service
              </a>
            </li>
            <li>
              <a href={SHIPPING_AND_RETURN} target='_blank' rel='noreferrer noopener'>
                Shipping and Return
              </a>
            </li>
            <li>
              <a href={ACCESSIBILITY_STATEMENT} target='_blank' rel='noreferrer noopener'>
                Accessibility Statement
              </a>
            </li>
          </ul>
          <ul className={style.SocialMedia} aria-label='Social links'>
            <li>
              <Link to={SOCIAL_MEDIA.linkedin} target='_blank' rel='noreferrer noopener'>
                <img src={linkedinSvg} alt="Innosearch's linkedin" />
              </Link>
            </li>
            <li>
              <Link to={SOCIAL_MEDIA.facebook} target='_blank' rel='noreferrer noopener'>
                <img src={facebookSvg} alt="Innosearch's facebook" />
              </Link>
            </li>
            <li>
              <Link to={SOCIAL_MEDIA.instagram} target='_blank' rel='noreferrer noopener'>
                <img src={instagramSvg} alt="Innosearch's instagram" />
              </Link>
            </li>
            <li>
              <Link to={SOCIAL_MEDIA.x} target='_blank' rel='noreferrer noopener'>
                <img src={xSvg} alt="Innosearch's x (twitter)" />
              </Link>
            </li>
          </ul>
        </div>
        <section className={style.Contact} aria-label='Contact information'>
          <div className={style.ContactItem}>
            <div className={style.Type}>
              Email<VisuallyHidden>:</VisuallyHidden>
            </div>
            <div>{EMAIL}</div>
          </div>
          <div className={style.ContactItem}>
            <div className={style.Type}>
              Address<VisuallyHidden>:</VisuallyHidden>
            </div>
            <div>{ADDRESS}</div>
          </div>
        </section>
        <div className={style.BackToTop}>
          <a href='#top'>
            <img src={backToTopSvg} alt='Back to top' />
          </a>
        </div>
      </div>
      <div className={style.AdditionalInfo} aria-label='Importants' role='list'>
        <div role='listitem'>© 2024 — @Innosearch.ai Copyright</div>
      </div>
    </footer>
  )
})
